import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["showFirst", "showPrevious", "showNext", "showLast", "padding", "totalPages"];
import React from 'react';
import { usePagination } from 'react-instantsearch-hooks';
import { Pagination as PaginationUiComponent } from "../ui/Pagination.js";
export function Pagination(_ref) {
  var showFirst = _ref.showFirst,
    showPrevious = _ref.showPrevious,
    showNext = _ref.showNext,
    showLast = _ref.showLast,
    padding = _ref.padding,
    totalPages = _ref.totalPages,
    props = _objectWithoutProperties(_ref, _excluded);
  var _usePagination = usePagination({
      padding: padding,
      totalPages: totalPages
    }, {
      $$widgetType: 'ais.pagination'
    }),
    pages = _usePagination.pages,
    currentRefinement = _usePagination.currentRefinement,
    isFirstPage = _usePagination.isFirstPage,
    isLastPage = _usePagination.isLastPage,
    nbPages = _usePagination.nbPages,
    createURL = _usePagination.createURL,
    refine = _usePagination.refine;
  var uiProps = {
    pages: pages,
    currentPage: currentRefinement,
    isFirstPage: isFirstPage,
    isLastPage: isLastPage,
    nbPages: nbPages,
    createURL: createURL,
    onNavigate: refine,
    translations: {
      first: '‹‹',
      previous: '‹',
      next: '›',
      last: '››',
      page: function page(currentPage) {
        return String(currentPage);
      },
      ariaFirst: 'First',
      ariaPrevious: 'Previous',
      ariaNext: 'Next',
      ariaLast: 'Last',
      ariaPage: function ariaPage(currentPage) {
        return "Page ".concat(currentPage);
      }
    }
  };
  return /*#__PURE__*/React.createElement(PaginationUiComponent, _extends({}, props, uiProps, {
    showFirst: showFirst,
    showPrevious: showPrevious,
    showNext: showNext,
    showLast: showLast
  }));
}